import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { pvqFinancialCivilJudgementItemValidator } from './validators/item';
import { FinancialCivilJudgementModel } from './types';

const financialCivilJudgementValidator: ValidateJSModel<FinancialCivilJudgementModel> = {
  HasCivilJudgement: {
    presence: true,
    hasValue: { validator: hasYesOrNo },
  },

  List: (value, attributes) => {
    if (attributes?.HasCivilJudgement?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: pvqFinancialCivilJudgementItemValidator },
      };
    }

    return {};
  },
};

export default financialCivilJudgementValidator;
